import { ReadonlyRepositoryListService, Result } from '@softline/core';
import { computed, inject, Injectable, Signal, signal } from '@angular/core';
import {
  BauprofiSupplierConfigQuery,
  BauprofiSupplierConfigRepository,
} from '../repositories/bauprofi-supplier-config.repository';
import { SupplierConfig } from '../types/supplier-config';

@Injectable()
export class BauprofiSupplierConfigService extends ReadonlyRepositoryListService<
  SupplierConfig,
  Result<SupplierConfig[]>,
  BauprofiSupplierConfigQuery
> {
  readonly configParams = signal<Signal<BauprofiSupplierConfigQuery | undefined>>(
    signal(undefined)
  );

  override params = computed(() => {
    return {
      supplierId: this.configParams()()?.supplierId,
    };
  });

  constructor() {
    super(inject(BauprofiSupplierConfigRepository));
  }

  setSupplierConfigParams(configParams: Signal<BauprofiSupplierConfigQuery | undefined>) {
    this.configParams.set(configParams);
  }

  protected override getItems(
    result: Result<SupplierConfig[]> | null | undefined
  ): SupplierConfig[] {
    return result as any;
  }
}
